import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const images = [
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/feb84a2a99fbcd7e8ff78c3e17f09320.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d3137d59be0cffa96f7aa072f468a8a7.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/7bf14301ee7a6b604645c9ec2aebae83.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2cd46f844316d9867f1ef19be25f2833.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/567ae914b096be40c10eb487428e7174.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a2515f1fc094fd8ff5b758d413294b54.jpeg",
];

const photos = [
  {
    alt: "remplacement sangle volet roulant Strasbourg",
    caption: "Remplacement de sangle usée sur volet roulant manuel",
  },
  {
    alt: "sangle 22 mm volet roulant Bas-Rhin",
    caption: "Pose d'une sangle de 22 mm sur volet lourd",
  },
  {
    alt: "technicien sangle volet roulant Strasbourg",
    caption: "Technicien contrôlant l'enrouleur et le guidage",
  },
  {
    alt: "enrouleur sangle volet roulant Bas-Rhin",
    caption: "Inspection de l'enrouleur avant remplacement",
  },
  {
    alt: "guidage sangle volet roulant Strasbourg",
    caption: "Vérification du guidage latéral de la sangle",
  },
  {
    alt: "sangle neuve volet roulant Strasbourg",
    caption: "Nouvelle sangle installée et testée",
  },
];

export default function Galerie() {
  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold text-center mb-3">
          Nos réalisations — remplacement de sangle
        </h2>
        <p className="text-[#2F4A63] text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Découvrez quelques-unes de nos interventions sur sangle de volet roulant à Strasbourg et dans le Bas-Rhin.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {photos.map((photo, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-[#E2E8F0] overflow-hidden"
            >
              <div className="w-full h-[240px] md:h-[280px] overflow-hidden">
                <ImagePlaceholder
                  src={images[index]}
                  alt={photo.alt}
                  className="w-full h-full"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <p className="text-[#2F4A63] text-sm">{photo.caption}</p>
                <p className="text-[#2F4A63]/50 text-xs mt-1">{photo.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}